import Flux from 'lib/flux';
import MessageService from 'services/message';
import MessageConstants from 'constants/message';

const MessageActionCreator = Flux.createActionCreator({
  sendMessage(params, onSuccessCallback) {
    const self = this;
    let onFullfilled;
    let onRejected;

    onFullfilled = function (resp) {
      self.dispatchAction(MessageConstants.SEND_MESSAGE_COMPLETED);
      onSuccessCallback(resp);
    };

    onRejected = function (resp) {
      const payload = { errors: { base: 'Something went wrong.' } };
      self.dispatchAction(MessageConstants.SEND_MESSAGE_FAILED, payload);
    };

    this.dispatchAction(MessageConstants.SEND_MESSAGE);
    MessageService.sendMessage(params).then(onFullfilled, onRejected);
  },
});

export default MessageActionCreator;
